import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useState } from 'react';
import { Modal, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { ModalActionBar } from "./ModalActionBar";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var ConsentDataProcessing = /*#__PURE__*/memo(function (_ref) {
  var className = _ref.className,
    personalDataButtonText = _ref.personalDataButtonText,
    personalDataTextFirst = _ref.personalDataTextFirst,
    personalDataTextSecond = _ref.personalDataTextSecond,
    policyModalButton = _ref.policyModalButton,
    policyModalText = _ref.policyModalText,
    policyModalTitle = _ref.policyModalTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var onClick = useCallback(function (e) {
    e.preventDefault();
    setModalIsOpen(true);
  }, [setModalIsOpen]);
  var changeVisibleModal = useCallback(function () {
    return setModalIsOpen(function (visible) {
      return !visible;
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: cn('footer__personal-data', className)
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('personal-data__text'),
    color: "grey60",
    size: "size7-r"
  }, personalDataTextFirst), /*#__PURE__*/React.createElement("a", {
    className: cn('personal-data__link'),
    href: "/",
    onClick: onClick
  }, personalDataButtonText), /*#__PURE__*/React.createElement(Text, {
    className: cn('personal-data__text'),
    color: "grey60",
    size: "size7-r"
  }, personalDataTextSecond)), /*#__PURE__*/React.createElement(Modal, {
    actionBar: /*#__PURE__*/React.createElement(ModalActionBar, {
      onClick: changeVisibleModal,
      text: policyModalButton
    }),
    headerBarConfig: {
      headerText: policyModalTitle
    },
    isOpen: modalIsOpen,
    onClose: changeVisibleModal,
    size: "m"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('modal')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('modal__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, policyModalText)))));
});